import React from 'react';
import AuthLayout, { AuthLink } from './AuthLayout';

function SignUp() {
  return (
    <AuthLayout title="Request an account" subtitle="Accounts are created by your administrator."
      footer={<AuthLink to="/login">Back to sign in</AuthLink>}>
      <p className="text-sm text-muted">Contact your administrator to request access to reports and work orders.</p>
    </AuthLayout>
  );
}

export default SignUp;
